import type { ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';

export interface GridProps {
  children: ReactNode;
  /**
   * Desktop column count. Steps to 2 at --bp-drawer and 1 at --bp-compact.
   *
   * Explicit rather than auto-fit on purpose: auto-fit with a 210px minimum fits three
   * tracks between 901 and 1024px, which orphans the fourth tile of a KPI row.
   */
  cols?: 1 | 2 | 3 | 4;
  /** Free-form template for asymmetric splits, e.g. the 1.6fr 1fr dashboard row. */
  template?: string;
  gap?: string;
  className?: string;
}

export function Grid({ children, cols = 1, template, gap, className }: GridProps) {
  const classes = ['grid'];
  if (!template) classes.push(`gridCols${cols}`);
  if (className) classes.push(className);

  return (
    <div
      className={classes.join(' ')}
      style={styleVars({ '--gap': gap }, template ? { gridTemplateColumns: template } : undefined)}
    >
      {children}
    </div>
  );
}
